import striptags from 'striptags';
import { decode as entitiesDecode } from 'html-entities';

const REGEX_HTML_CHARS = /<|(&.+;)/;

const decode = (string) => {
  let decodedString = string;
  if (REGEX_HTML_CHARS.test(string)) {
    // strip html tags from string
    decodedString = striptags(string);
    // decode html entities
    decodedString = entitiesDecode(decodedString);
  }
  // return decoded string
  return decodedString;
};

export default decode;
